import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-widget',
  standalone: true,
  templateUrl: './no-data-widget.component.html',
  styleUrl: './no-data-widget.component.scss'
})
export class NoDataWidgetComponent {
  @Input() icon = 'svg/no-widget-data.svg';
  @Input() title = 'No Data Found';
  @Input() message = 'Try adjusting your filters.';
  @Input() iconSize = '120px';
}

